import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchContactRequests } from "../../slices/contactSlice";
import ContactDetail from "../../Components/contactDetailAdmin";

const ManageContacts = () => {
  const { contactRequests } = useSelector((state) => state.contacts);
    const [detailOpen, setDetailOpen] = useState(false);
    const [selectedContact, setContact] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchContactRequests());
  }, [dispatch]);

  const openDetail = (contact) => {
    setContact(contact);
    setDetailOpen(true);
  };
  return (
    <section className="managecontacts-section">
      <div className="top">
        <ul className="users-card-list">
          <li>
            <a style={{cursor:"pointer"}} onClick={() => dispatch(fetchContactRequests())}>
              Yenilə
            </a>
          </li>
        </ul>
      </div>
      <div className="table-container">
        <table
          className="tab-contacts"
          border="1"
          style={{ width: "100%", textAlign: "left" }}
        >
          <thead>
            <tr>
              <th>ID</th>
              <th>Ad</th>
              <th>Email</th>
              <th>Telefon nomresi</th>
              <th>Mövzu</th>
              <th>Mesaj</th>
              <th>Tarix</th>
            </tr>
          </thead>
          <tbody>
            {contactRequests.map((request) => (
              <tr key={request.id}>
                <td className="id-tr" onClick={()=>openDetail(request)}>{request.id}</td>
                <td style={{ textWrap: "nowrap" }}>{request.name}</td>
                <td>{request.email}</td>
                <td>{request.phonenumber}</td>
                <td>{request.subject}</td>
                <td>
                  {request.message.length > 10
                    ? request.message.substring(0, 10) + "..."
                    : request.message}
                </td>
                <td style={{ textWrap: "nowrap" }}>
                  {request.createdAt.split("T")[0]}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>


      {detailOpen && <ContactDetail isOpen={detailOpen} onClose={()=>setDetailOpen(false)} contact={selectedContact}/>}
    </section>
  );
};

export default ManageContacts;
